<template>
  <div>
    <el-dialog title="客户调用" :visible.sync="disableDialog" width="60%">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-select v-model="queryParams.column" @change="changeColumn">
            <el-option
              v-for="(item,index) in searchCustomerList"
              :label="item.label"
              :value="item.value"
              :key="index"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input v-model="queryParams.value" placeholder="请输入关键词"></el-input>
        </el-col>
        <el-col :span="8">
          <el-button @click="onSearch" type="primary">搜索</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-col>
        <el-col :span="4" style="text-align:right;">
          <el-button @click="onAddCustomer" type="primary" plain>添加客户</el-button>
        </el-col>
      </el-row>
      <el-table
        style="margin-top:20px;"
        :data="list"
        @current-change="handleChange"
        highlight-current-row
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        v-loading="loadingTable"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
        border
        height="378"
      >
        <el-table-column prop="cusName" label="客户名称" min-width="210" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ccContacts" label="联系人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ccPhone" label="联系电话" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ccMobile" label="联系手机" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bizProvince" label="经营地址" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bizAddress" label="详细地址" min-width="150" show-overflow-tooltip></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[30, 50, 100, 200]"
          :page-size="pageSize"
          :total="total"
        ></el-pagination>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="onSubmit">确 定</el-button>
        <el-button @click="disableDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!------------ 快速添加客户 ------------>
    <quick-add-custormer ref="quickAddCustormerRefs" @getList="onReset"></quick-add-custormer>
  </div>
</template>
<script>
import quickAddCustormer from '../../crm/components/custorm/dialog/quickAddCustormer'
import { customerList } from '../util/data'
import {
  financialTransferCustomerInformation,
  queryByOwnId,
  queryCustomerCreditById
} from '@/api/customer/customerManage'
export default {
  components: {
    'quick-add-custormer': quickAddCustormer
  },
  props: ['isfinish'],
  data () {
    return {
      queryParams: {
        column: 'cusName',
        value: ''
      },
      disableDialog: false,
      columnArr: [],
      searchCustomerList: customerList, // 客户调用搜索条件
      list: [], // 客户调用列表
      loadingTable: false, // 列表loading
      total: 0,
      currentPage: 1,
      pageSize: 30
    }
  },
  watch: {
    queryParams (val) {
      if (!val.column) {
        this.$set(this.queryParams, 'column', 'cusName')
      }
    }
  },
  methods: {
    // 调入客户调用初始化方法
    onInitial () {
      this.disableDialog = true
      this.onReset()
    },
    onReset () {
      this.queryParams = {}
      this.columnArr = []
      this.pageSize = 30
      this.currentPage = 1
      this.getList()
    },
    onSearch () {
      // 搜索
      if (this.queryParams.column && this.queryParams.value) {
        this.pageSize = 30
        this.currentPage = 1
        this.columnArr = [this.queryParams]
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空！')
      }
    },
    // 调用客户列表
    getList () {
      const params = {
        criteriaVoList: [...this.columnArr],
        queryPageName: ''
      }
      if (this.isfinish) {
        financialTransferCustomerInformation(this.currentPage, this.pageSize, params)
          .then((res) => {
            if (res.data.code === 200) {
              this.list = res.data.obj.records
              this.total = res.data.obj.total
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else {
        queryByOwnId(this.currentPage, this.pageSize, params)
          .then((res) => {
            if (res.data.code === 200) {
              this.list = res.data.obj.records
              this.total = res.data.obj.total
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    changeColumn () {
      delete this.queryParams.value
    },
    // 列表选中的数据
    handleChange (val) {
      this.checkObj = val
    },
    // 添加客户
    onAddCustomer () {
      this.$refs.quickAddCustormerRefs.quickAddInit()
    },
    // 确定
    onSubmit () {
      if (!this.checkObj) {
        this.$message.error('请选择客户！')
        return
      }
      queryCustomerCreditById(this.checkObj.id).then((res) => {
        if (res.data.code === 200) {
          this.$emit('onRefresh', res.data.obj)
          this.$message.success('调用成功！')
          this.disableDialog = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
